import {
  INDIVIDU_INICIALITZAR,
  OBTENIR_INDIVIDUS_LLISTAT,
  OBTENIR_DADES_INDIVIDU
} from "../../actions/actionTypes";

const ESTAT_INICIAL = false;

const peticioEnCurs = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INDIVIDU_INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_INDIVIDUS_LLISTAT}_EN_CURS`:
    case `${OBTENIR_DADES_INDIVIDU}_EN_CURS`:
      return true;

    case `${OBTENIR_INDIVIDUS_LLISTAT}_SUCCESS`:
    case `${OBTENIR_INDIVIDUS_LLISTAT}_ERROR`:
    case `${OBTENIR_DADES_INDIVIDU}_SUCCESS`:
    case `${OBTENIR_DADES_INDIVIDU}_ERROR`:
      return false;

    default:
      return state;
  }
};

export default peticioEnCurs;

export const getPeticioEnCurs = state => state;
export const getPeticioError = state => state.error;
